import { render, staticRenderFns } from "./dre.vue?vue&type=template&id=3b735c9f&scoped=true"
import script from "./dre.vue?vue&type=script&lang=js"
export * from "./dre.vue?vue&type=script&lang=js"
import style0 from "./dre.vue?vue&type=style&index=0&id=3b735c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b735c9f",
  null
  
)

export default component.exports